export enum CurrencyEnum {
  Pesos = "AR$",
  Dolar = "U$D",
  Porcentaje = "%",
  Euro = "EUR",
  Real = "BRL",
  Cripto = "Cripto",
  DolarCable = "Dolar Cable",
  Cheque = "Cheque",
  PesoChileno = 'Peso Chileno',
  PesoMep = 'Peso Mep',
  Libra = "Libra"
}

export enum StateEnum {
  Draft = "Draft",
  Publish = "Publish",
}

export enum OrderCurrency {
  Dolar = "Dolar",
  Pesos = "Pesos",
  Euro = "Euro",
  Real = "Real",
  Cripto = "Cripto",
  DolarCable = "Dolar Cable",
  Cheque = "Cheque",
  DolarCaraChica = "Dolar Cara Chica",
  PesoChileno = 'Peso Chileno',
  PesoMep = 'Peso Mep',
  Libra = "Libra"
}

export enum ConciliationCurrency {
  Dolar = "USD",
  Pesos = "ARS",
  Euro = "EURO",
  Real = "REAL",
  Porcentaje = "%",
  Cripto = "USDT",
  DolarCable = "CABLE",
  Cheque = "CHEQUE",
  DolarCaraChica = "CARA CHICA",
  Usdt = "USDT",
  PesoChileno = 'Peso Chileno',
  PesoMep = 'Peso Mep',
  Libra = "Libra"
}

export enum ConciliationStatus {
  Pending = "Pendiente",
  Partial = "Parcial",
  Complete = "Completado",
}

export enum TrendEnum {
  Desc = "Desc",
  Equal = "Equal",
  Asc = "Asc",
}

export enum TrayEnum {
  MyOrders = 1,
  Treasury = 2,
  Logistics = 3,
  Intravel = 4,
  Done = 5,
  Reception = 6,
  Transfered = 7,

}

export enum OrderStepIcons {
  Draft = "pending",
  Publish = "pending",
  TreasuryPreparation = "pending",
  LogisticsPreparation = "pending",
  TransferPreparation = "pending",
  Delivery = "pending",
  LogisticsReception = "pending",
  ReceptionTesoreria = "pending",
  TreasuryVerification = "pending",
  LogisticsVerification = "pending",
  TransferVerification = "pending",
  Done = "check_circle",
  Cancel = "cancel",
  Reception = "pending",
}

export enum OrderStep {
  Draft = "Borrador",
  Publish = "Publicado",
  TreasuryPreparation = "En preparación",
  LogisticsPreparation = "En preparación",
  TransferPreparation = "En preparación",
  Delivery = "Viajando",
  LogisticsReception = "Recepción",
  ReceptionTesoreria = "Recepción",
  TreasuryVerification = "Verificación",
  LogisticsVerification = "Verificación",
  TransferVerification = "Verificación",
  Done = "Finalizado",
  Cancel = "Cancelado",
  Reception = "Esperando Cliente",
  PendingSuborders = "Subordenes en proceso",
}

export enum OrderState {
  Draft = "Borrador",
  Publish = "Publicado",
  TreasuryPreparation = "Tesorería preparación",
  LogisticsPreparation = "Logística preparación",
  TransferPreparation = "Transferencia preparación",
  Delivery = "Viaje",
  LogisticsReception = "Logística Recepción",
  ReceptionTesoreria = "Tesorería Recepción",
  TreasuryVerification = "Tesorería Verificación",
  LogisticsVerification = "Logística Verificación",
  TransferVerification = "Transferencia Verificación",
  Done = "Finalizado",
  Cancel = "Cancelado",
  Reception = "Recepción",
}

export enum OrderStateIcons {
  Draft = "",
  Publish = "",
  TreasuryPreparation = "Tesorería preparación",
  LogisticsPreparation = "Logística preparación",
  TransferPreparation = "Transferencia preparación",
  Delivery = "",
  LogisticsReception = "Logística Recepción",
  ReceptionTesoreria = "Tesorería Recepción",
  TreasuryVerification = "Tesorería Verificación",
  LogisticsVerification = "Logística Verificación",
  TransferVerification = "Transferencia Verificación",
  Done = "",
  Cancel = "",
  Reception = "",
}

export enum ActionEnum {
  Create,
  Update,
  Continue,
  Cancel,
  Complete,
  View,
  Delete,
  Edit,
  UploadFile,
  DeliveryMessage,
  ReportDelay,
  Undo,
  AmountDiscrepancy,
  SendTransferAssign,
  ReceiveTransferAssign,
  AssignDelivery,
  ModifyProducers,
}

export enum OrderTabs {
  Draft,
  Bursar,
  Usher,
  Ship,
  Transfer,
  End,
}

export enum FileTypeDTO {
  Transfer = "Transferencia",
  Deposit = "Depósito",
  BankCheck = "Recibo bancario",
  Other = "Otro",
}

export enum NotificationType {
  KeyWord,
  DeliveryRead,
  DeliveryResponse,
  DeliveryFile,
  Delay,
  CreatePaymentRequest,
  CustomerActionPaymentRequest,
  BugReportComment,
  BugReportUpdate,
  AssignmentFinalized,
  AssignmentInCourse,
  AssignmentCreateUpdate,
  AssignmentNews,
  MyAssignmentNews,
}

export enum ProductCurrency {
  Pesos = "ARS",
  Usd = "USD",
  Usdt = "USDT",
  Real = "BRL",
}

export enum ProducerCurrency {
  Dolar = "Dolar",
  Pesos = "Pesos",
}


export enum FormatTemporality {
  MinutesAndHours,
  DateAndTime,
}

export enum ExchangeStatus {
  WithinAverage = "Sin desviación", // En el promedio de cotizaciones
  BelowAverage = "Desviación positiva", // por arriba (Ganas mas de lo esperado)
  AboveAverage = "Desviación negativa", // Por abajo estas perdiendo plata
  NotCalculated = "No calulado", // No calulado
}


export enum AccountBalanceIcons {
  Dolar = 'usa',
  Pesos = 'arg',
  Cripto = 'usdt',
  Usdt = 'usdt',
  Real = 'brz',
  Libra = 'eng',
  Bitcoin = 'btc',
  Euro = 'eur',
  DolarCable = 'usa',
  DolarCaraChica = 'usa',
  Cheque = 'arg',
  PesoChileno = 'clp',
  PesoMep = 'arg',
  test= 'btc'
}


export enum OrderValueProperties {
  sendCurrency,
  sendValue,
  sendExchangeTypeValue,
  sendCurrency2,
  sendValue2,
  sendExchangeTypeValue2,
  sendSuplierCurrency,
  sendSuplierValue,
  sendSuplierExchangeTypeValue,
  receiveCurrency,
  receiveValue,
  receiveExchangeTypeValue,
  receiveCurrency2,
  receiveValue2,
  receiveExchangeTypeValue2,
  receiveSuplierCurrency,
  receiveSuplierValue,
  receiveSuplierExchangeTypeValue
}

export enum OrderView {
  Classic,
  Compact
}

export enum OrderConfigurationMode {
  AllowSingleEntry = "Una sola parte",
  DualEntryRequired = "Obligación de llenar ambas partes",
  AutoCounterpartyToCustomerAccount = "Generar automáticamente la contraparte",
}

export enum OrderCreateType {
  Standard,
  PendingToCash,
  PendingBetweenClients,
  BetweenOffices
}

export enum ProducerCommissionType {
  Percentage = "Porcentaje",
  Value = "Valor fijo",
  Spread = "Diferencia TC",
  RatePerCurrency = "Valor por moneda"
}
